import * as React from 'react';
import { flow, forEach, get, find } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import SpecifiedDriver from '../SpecifiedDriver';
import {IDriver, IVehicle} from '../../../../../../data/api/models';
import {Button} from 'react-bootstrap';
import CreateDriverButton from '../../../../components/CreateDriverButton';
import * as uuid from 'uuid/v4';

interface ISpecifiedDriversProps {
  baseName: string;
  fields: any;
  dispatch: any;
  change: any;
  vehicle: IVehicle;
  drivers: IDriver[];
}

const defaults = {
  driver: '',
};

class SpecifiedDrivers extends React.Component<ISpecifiedDriversProps> {
  public addSpecifiedDriver = () => {
    const { fields } = this.props;

    fields.push(defaults);
  }

  public createDriver = (data) => {
    const { dispatch, change, fields, drivers } = this.props;

    if (data) {
      const newDriverId = uuid();

      const defaultDriver = {
        id: newDriverId,
        proposer: false,
        dob: '',
        title: data.title,
        firstName: data.firstName,
        lastName: data.lastName,
        typeOfLicence: '',
        lengthOfLicence: '',
        nonEquineTrade: '',
        vehicles: [],
        claims: [],
        convictions: [],
      };

      const defaultVehicleDriver = {
        driver: `${newDriverId}`,
      };

      let foundIndex = -1;
      forEach(drivers, (driver, index) => {
        if (driver.firstName === data.firstName && driver.lastName === data.lastName) {
          foundIndex = index;
        }
      });

      if (foundIndex === -1) {
        drivers.push(defaultDriver);
        fields.push(defaultVehicleDriver);
        dispatch(change('driverCount', drivers.length));
      }
    }
  }

  public driverOptions() {
    const { vehicle, drivers } = this.props;

    return drivers.map((driver, key) => {
      let label = `Driver ${(key + 1)} (No name provided)`;

      if (driver.title || driver.firstName || driver.lastName) {
        label = driver.title + ' ' + driver.firstName + ' ' + driver.lastName;
      }

      return {
        label,
        value: driver.id,
        disabled: false, // find(vehicle.drivers, { driver: driver.id }),
      };
    });
  }

  public render() {
    const { fields, baseName, drivers, dispatch, change } = this.props;
    return (
      <div>
        {fields.map((driver, index) => {
          return (
            <div key={index}>
              <SpecifiedDriver
                name={`${baseName}[${index}]`}
                index={index}
                fields={fields}
                driverOptions={this.driverOptions()}
              />
            </div>
          );
        })}
        {fields.length < 6 && (
          <div>
            {drivers.length > 0 && (
              <Button
                bsStyle="primary"
                className="btn-postcode"
                type="button"
                style={{ marginRight: '15px' }}
                onClick={this.addSpecifiedDriver}
              >
                Add Existing Driver
              </Button>
            )}
            <CreateDriverButton
              callback={this.createDriver}
              dispatch={dispatch}
              change={change}
            />
          </div>
        )}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const drivers = selector(state, 'drivers');

      return {
        quote: state.quote,
        drivers,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(SpecifiedDrivers);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/components/SpecifiedDrivers/index.tsx